import { SxProps, Theme } from '@mui/system';

export const datePicker: SxProps<Theme> = {
  marginTop: '16px',
  marginBottom: '8px',
};
